import { render, staticRenderFns } from "./AboutAffiliatePlus.vue?vue&type=template&id=837e87b8"
import script from "./AboutAffiliatePlus.vue?vue&type=script&lang=js"
export * from "./AboutAffiliatePlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports